import React from "react";

function SvgIcMapPoi048(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M24 10.333A4.331 4.331 0 0019.669 6 4.326 4.326 0 0016 8.036 4.326 4.326 0 0012.331 6 4.332 4.332 0 008 10.333c0 1.568.836 2.938 2.082 3.698C10.349 18.204 11.224 25 13.016 25c1.589 0-.292-6.57 2.973-7.047C19.254 18.43 17.422 25 19.012 25c1.79 0 2.634-6.784 2.888-10.957a4.33 4.33 0 002.1-3.71"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi048;
